import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
var RouterParams = /** @class */ (function () {
    // I initialize the router params service.
    function RouterParams(router) {
        var _this = this;
        this.router = router;
        this.paramsSnapshot = {};
        this.params = new BehaviorSubject(this.paramsSnapshot);
        // We will collection the params after every Router navigation event. However,
        // we're going to defer param aggregation until after the NavigationEnd event.
        // This should leave the Router in a predictable and steady state.
        this.router.events
            .pipe(filter(function (event) {
            return (event instanceof NavigationEnd);
        }))
            .subscribe(function (event) {
            var snapshot = _this.router.routerState.snapshot.root;
            var nextParams = _this.collectParams(snapshot);
            // A Router navigation event can occur for a variety of reasons, such
            // as a change to the search-params. As such, we need to inspect the
            // params to see if the structure actually changed with this
            // navigation event. If not, we don't want to emit an event.
            if (_this.paramsAreDifferent(_this.paramsSnapshot, nextParams))
                _this.params.next(_this.paramsSnapshot = nextParams);
        });
    }
    RouterParams.prototype.collectParams = function (root) {
        var params = {};
        (function mergeParamsFromSnapshot(snapshot) {
            Object.assign(params, snapshot.params, snapshot.queryParams);
            snapshot.children.forEach(mergeParamsFromSnapshot);
        })(root);
        return (params);
    };
    // I determine if the given param collections have a different [shallow] structure.
    RouterParams.prototype.paramsAreDifferent = function (currentParams, nextParams) {
        var currentKeys = Object.keys(currentParams);
        var nextKeys = Object.keys(nextParams);
        // If the collection of keys in each set of params is different, then we know
        // that we have two unique collections.
        if (currentKeys.length !== nextKeys.length) {
            return (true);
        }
        // If the collections of keys have the same length then we have to start
        // comparing the individual KEYS and VALUES in each collection.
        for (var i = 0, length_1 = currentKeys.length; i < length_1; i++) {
            var key = currentKeys[i];
            if (currentParams[key] !== nextParams[key])
                return (true);
        }
    };
    RouterParams.ngInjectableDef = i0.defineInjectable({ factory: function RouterParams_Factory() { return new RouterParams(i0.inject(i1.Router)); }, token: RouterParams, providedIn: "root" });
    return RouterParams;
}());
export { RouterParams };
